import { useParams } from "react-router-dom";
import { Stack } from "@/core/components/ui/stack";
import { InternalTransactionsTable } from "@/internal-transactions/internal-transactions-table";
import { useGetInternalTransactions } from "@/internal-transactions/query";

export const InternalTransactions = () => {
  const { businessId } = useParams();
  const { data: internalTransactions = [] } =
    useGetInternalTransactions(businessId);

  return (
    <Stack className="h-full pr-1" fullWidth>
      <InternalTransactionsTable data={internalTransactions} />
    </Stack>
  );
};
